import React from 'react';

import { useStartupCXI } from '../../useStartupCXI';

import { Container } from '../container';
import * as Styled from './StyledGuide';

export const Guide = () => {
    const { t } = useStartupCXI();

    return (
        <Styled.Guide as={Container.Slim}>
            <Container.Head>
                <span className="text">{t('menu.guide')}</span>
            </Container.Head>

            <Container.Body>
                <iframe
                    src="https://www.youtube-nocookie.com/embed/_Tlp8FWGC9M?controls=0"
                    title="Como começar a contribuir com Startups"
                />
            </Container.Body>

            <Container.Feet>
                <p>Para começar a utilizar, clique no botão Conhecer Startups.</p>

                <p>
                    Você será direcionado para uma página onde receberá sugestões de startups que se
                    adequam ao perfil que você selecionou ao ingressar no programa pela primeira
                    vez. Se acha que a startup não se adeque às necessidades da sua empresa, aperta
                    o botão “Não quero avaliar”.
                </p>

                <p>
                    Caso o card tenha chamado sua atenção e você tenha interesse em
                    obter mais informações sobre uma solução, clique em "Quero Avaliar".
                    Você será redirecionado para o perfil da startup e, se desejar
                    conectar-se com ela, basta clicar no botão “Avaliar Startup".
                </p>

                <p>
                    No card que surgirá, você pode indicar o potencial que visualiza na startup e
                    deixar um feedback, ou seja, dicas ou comentários com base em sua bagagem
                    profissional que ajudarão aquele pequeno negócio a chegar ainda mais longe.
                </p>

                <p>
                    Tendo avaliado a startup, você deve aguardar enquanto ela aponta a relevância do
                    feedback enviado. Quando sua contribuição é avaliada positivamente, você
                    receberá um ponto no seu contador do programa. Após isso, você poderá solicitar
                    Speed-Datings, reuniões de até 18 minutos que acontecem durante a Oiweek; ou
                    iniciar um processo de mentoria com a startup.
                </p>
            </Container.Feet>
        </Styled.Guide>
    );
};
